import { render, staticRenderFns } from "./GlassproductsPage.vue?vue&type=template&id=afe0e802"
import script from "./GlassproductsPage.vue?vue&type=script&lang=js"
export * from "./GlassproductsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports